export default {
    _prefix: "qualityFormViewer.footer",
    labels: {
        agentHasReviewed: "The Agent Has Reviewed This Evaluation",
        reviewedEvaluation: "I Have Reviewed This Evaluation",
        edit: "Edit",
        delete: "Delete",
        saveReleaseDate: "Save Release Date",
        submit: "Submit",
        save: "Save",
        decline: "Decline Dispute",
        signOff: "Sign Off",
        dispute: "Dispute",
        saveComment: "Save Comment",
        reviseScore: "Revise Score",
        apply: "Apply",
        assign: "Assign",
        submitAndAssign: "Submit and Assign",
        comments: "Comments",
        evaluatorComments: "Evaluator Comments",
        overallComments: "Overall Evaluation Comments",
        addComments: "Add Comments ...",
        cancel: "Cancel",
        createCalibration: "Create Calibration",
        commentCharLimitExceeded: (data: { characterLimit: number }) =>
            "Comment must not exceed {{characterLimit}} characters",
        agentComments: "Agent Comments ",
        reviewComments: "Review Comments",
        privateComments: "Private Comments",
        privateCommentsTooltip:
            "Private Comments are not viewable by the Agent in the evaluation.",
        privateCommentsSaveTooltip:
            "Private Comments are not savable if unchanged.",
        releaseDateExpired: (data: { releaseDateExpiry: number }) =>
            "Evaluation cannot be released because this evaluation was created more than {{releaseDateExpiry}} days ago",
        scoringExpired: (data: { scoringExpiry: number }) =>
            "Evaluation cannot be scored because this evaluation was created more than {{scoringExpiry}} days ago",
        deletingExpired: (data: { deletingExpiry: number }) =>
            "Evaluation cannot be deleted because this evaluation was created more than {{deletingExpiry}} days ago",
        agentReviewExpired: (data: { agentReviewExpiry: number }) =>
            "Evaluation cannot be reviewed because this evaluation was created more than {{agentReviewExpiry}} days ago",
        tooltips: {
            assigneeExpired:
                "The time limit for assigning this evaluation has been reached",
            disputeExpired:
                "The time limit for disputing this evaluation has been reached.",
            disputeLimit:
                "The maximum number of disputes for this evaluation has been reached.",
        },
    },
    assignEvaluation: {
        fail: {
            title: "Assign Evaluation Failed",
            message: "The attempt to assign the evaluation has failed.",
        },
        success: {
            message: (data: {
                evaluationTitle: string;
                assigneeName: string;
            }) => "{{evaluationTitle}} has been assigned to {{assigneeName}}.",
        },
        unassignSuccess: (data: { evaluationTitle: string }) =>
            "{{evaluationTitle}} has been unassigned.",
    },
    createCalibration: {
        fail: {
            title: "Calibration Creation Failed",
            message: "The attempt to create the calibration has failed.",
        },
        success: {
            title: "Calibration Creation Succeeded",
            message: "The attempt to create the calibration has succeeded.",
        },
    },
    saveComment: {
        fail: {
            message: "Comment failed to save.",
        },
        success: {
            message: "Comment saved.",
        },
    },
    errors: {
        evaluationUpdateFail: "The request to update the evaluation failed.",
        abacUpdateDenied:
            "The request to update the evaluation failed. Your organization's security policies have denied access",
        privateCommentsUpdateFail:
            "You do not have the permissions needed to update the private comments for this evaluation.",
    },
};
